import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import KickoffAlerts from "@/components/KickoffAlerts";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Profile from "@/pages/Profile";
import VerifyEmail from "@/pages/VerifyEmail";
import Dashboard from "@/pages/Dashboard";
import Standings from "@/pages/Standings";
import Results from "@/pages/Results";
import Players from "@/pages/Players";
import Teams from "@/pages/Teams";
import TeamRoster from "@/pages/TeamRoster";
import Transfers from "@/pages/Transfers";
import Streamers from "@/pages/Streamers";
import StreamerSignup from "@/pages/StreamerSignup";
import Dossier from "@/pages/Dossier";
import Bracket from "@/pages/Bracket";
import Live from "@/pages/Live";
import LiveMatch from "@/pages/LiveMatch";
import Trophies from "@/pages/Trophies";
import Predictions from "@/pages/Predictions";
import MyTeam from "@/pages/MyTeam";
import FreeAgents from "@/pages/FreeAgents";
import Recruitment from "@/pages/Recruitment";
import Admin from "@/pages/Admin";
import Streams from "@/pages/Streams";
import Rulebook from "@/pages/Rulebook";
import Vault from "@/pages/Vault";
import Officials from "@/pages/Officials";
import RepsToolkit from "@/pages/RepsToolkit";
import Schedule from "@/pages/Schedule";
import CastCalendar from "@/pages/CastCalendar";
import RepDashboard from "@/pages/RepDashboard";
import MatchPredict from "@/pages/MatchPredict";
import PlayerCareerCard from "@/pages/PlayerCareerCard";
import NotFound from "@/pages/NotFound";
import { OverlayScorebug, OverlayNextMatch, OverlayPredictionPoll, OverlayHero, OverlayRosters } from "@/pages/overlays/Overlays";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <KickoffAlerts />
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/standings" element={<Standings />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/results" element={<Results />} />
              <Route path="/players" element={<Players />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/teams/:teamId" element={<TeamRoster />} />
              <Route path="/transfers" element={<Transfers />} />
              <Route path="/streamers" element={<Streamers />} />
              <Route path="/streamers/signup" element={<StreamerSignup />} />
              <Route
                path="/streamers/me/cast-calendar"
                element={<ProtectedRoute><CastCalendar /></ProtectedRoute>}
              />
              <Route path="/streamers/:id" element={<Dossier />} />
              <Route path="/bracket" element={<Bracket />} />
              <Route path="/live" element={<Live />} />
              <Route path="/live/:id" element={<LiveMatch />} />
              <Route path="/trophies" element={<Trophies />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route
                path="/my-team"
                element={<ProtectedRoute><MyTeam /></ProtectedRoute>}
              />
              <Route path="/free-agents" element={<FreeAgents />} />
              <Route path="/recruitment" element={<Recruitment />} />
              <Route path="/streams" element={<Streams />} />
              <Route path="/rulebook" element={<Rulebook />} />
              <Route path="/vault" element={<Vault />} />
              <Route
                path="/admin"
                element={<ProtectedRoute><Admin /></ProtectedRoute>}
              />
              <Route
                path="/officials"
                element={<ProtectedRoute><Officials /></ProtectedRoute>}
              />
              <Route
                path="/reps"
                element={<ProtectedRoute><RepsToolkit /></ProtectedRoute>}
              />
              <Route
                path="/rep-dashboard"
                element={<ProtectedRoute><RepDashboard /></ProtectedRoute>}
              />
              <Route
                path="/match"
                element={<MatchPredict />}
              />
              <Route
                path="/dashboard"
                element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
              />
              <Route path="/player/:handle" element={<PlayerCareerCard />} />
              <Route path="/player-id/:playerId" element={<PlayerCareerCard />} />
              {/* OBS Browser Sources — public, no chrome */}
              <Route path="/overlay/scorebug/:id" element={<OverlayScorebug />} />
              <Route path="/overlay/next-match" element={<OverlayNextMatch />} />
              <Route path="/overlay/prediction-poll/:id" element={<OverlayPredictionPoll />} />
              <Route path="/overlay/hero/:id" element={<OverlayHero />} />
              <Route path="/overlay/rosters/:id" element={<OverlayRosters />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
